import { testimonials } from "../../../mocks/testimonials";

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-20 md:py-28 bg-[#F7FAF8]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-[#C9A227] text-xs font-bold tracking-widest uppercase border border-[#C9A227] px-3 py-1 rounded-full mb-4">
            Client Reviews
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            What Our Global Buyers Say
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-xl mx-auto">
            Trusted by importers, traders, and food businesses across the world.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-white rounded-2xl p-7 border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-default flex flex-col"
            >
              {/* Quote icon */}
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#D8F3DC] text-[#2D6A4F] mb-4">
                <span className="text-xl">
                  <i className="ri-double-quotes-l"></i>
                </span>
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center text-[#C9A227]">
                    <i className="ri-star-fill text-sm"></i>
                  </span>
                ))}
              </div>

              {/* Text */}
              <p className="text-gray-600 text-sm leading-relaxed flex-1 mb-6">
                &ldquo;{t.text}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-5 border-t border-gray-100">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1B4332] text-[#C9A227] font-bold text-base flex-shrink-0">
                  {t.name.split(" ").map((n) => n[0]).join("")}
                </div>
                <div>
                  <p className="text-sm font-bold text-[#1B4332]">{t.name}</p>
                  <p className="text-xs text-gray-400">{t.company}</p>
                  <div className="flex items-center gap-1 mt-0.5">
                    <span className="w-3 h-3 flex items-center justify-center text-[#C9A227]">
                      <i className="ri-map-pin-line text-xs"></i>
                    </span>
                    <p className="text-xs text-gray-400">{t.location}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA row */}
        <div className="text-center mt-14">
          <p className="text-gray-500 text-base mb-5">Ready to join our growing network of global buyers?</p>
          <button
            onClick={() => window.open("https://wa.me/917584050023?text=Hello%20Pandit%20Export%2C%20I%20would%20like%20to%20enquire%20about%20your%20products.", "_blank")}
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1fbb58] text-white font-bold px-8 py-4 rounded-full transition-all duration-200 cursor-pointer shadow-md hover:shadow-lg whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg"></i>
            </span>
            WhatsApp Us Now
          </button>
        </div>
      </div>
    </section>
  );
}
